import { Locale, type LocalizedString } from "../Locale.js";
import { ProductAttributeGroupType } from "../ProductAttributeGroupType.js";

export const productAttributeGroupTypeNameMap: Record<ProductAttributeGroupType, LocalizedString> = {
	[ProductAttributeGroupType.Color]: {
		[Locale.cs]: "Barva",
		[Locale.en]: "Color",
	},
};
